import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout, isAuthenticated } from '../services/auth';
import { useAuthModal } from '../contexts/AuthModalContext';
import Button from './Button';
import Logo from './Logo';
import SupportModal from './SupportModal';
import './Navbar.css';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const authenticated = isAuthenticated();
  const { openLoginModal, openRegisterModal } = useAuthModal();
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <Logo size={32} />
          <span className="logo-text">Nuru</span>
          <span className="logo-accent">Subs</span>
        </Link>

        <div className="navbar-menu">
          {authenticated ? (
            <>
              <Link to="/dashboard" className="navbar-link">Dashboard</Link>
              <Link to="/upload" className="navbar-link">Upload</Link>
              <Link to="/usage" className="navbar-link">Usage</Link>
              <button 
                onClick={() => setIsSupportModalOpen(true)} 
                className="navbar-link navbar-link-button"
              >
                <span className="support-icon-nav">❓</span> Help & Support
              </button>
              <Button variant="secondary" onClick={handleLogout}>
                Logout
              </Button>
            </>
          ) : (
            <>
              <button onClick={openLoginModal} className="navbar-link navbar-link-button">Login</button>
              <Button variant="primary" onClick={openRegisterModal}>Get Started</Button>
            </>
          )}
        </div>
      </div>

      <SupportModal 
        isOpen={isSupportModalOpen} 
        onClose={() => setIsSupportModalOpen(false)} 
      />
    </nav>
  );
};

export default Navbar;
